import getInteractionEventId from '@/lib/threadInteractions/getInteractionEventId.js';
import toResolvedInteractionIdSet from '@/lib/threadInteractions/toResolvedInteractionIdSet.js';
import dedupeThreadEventsByIdentity from '@/lib/threadEvents/dedupeThreadEventsByIdentity.js';
import { isChecklistUpdateLifecycleEvent } from '@/lib/threadChecklist.js';
import { isDismissedConnectionPrompt } from '@/lib/threadInteractions/connectionPromptVisibility.js';
import resolveApprovalDecisionsFromActivity from '@/redux/selectors/lib/resolveApprovalDecisionsFromActivity.js';

const EMPTY_ARRAY = [];

const resolveVisibleThreadActivity = ({ activity = [] } = {}) => {
  const normalizedActivity = resolveApprovalDecisionsFromActivity({
    activity: Array.isArray(activity) ? activity : EMPTY_ARRAY
  });

  if (normalizedActivity.length < 1) {
    return EMPTY_ARRAY;
  }

  const resolvedInteractionIds = toResolvedInteractionIdSet(normalizedActivity);
  let didFilterAnyItems = false;
  const filteredActivity = normalizedActivity.filter((item) => {
    const normalizedType = String(item?.type || '')
      .trim()
      .toLowerCase();

    if (isChecklistUpdateLifecycleEvent(item)) {
      didFilterAnyItems = true;
      return false;
    }

    if ((item?.interactionType === 'permission_approval' || item?.interactionType === 'thread_mode_conversion') && normalizedType !== 'approval') {
      didFilterAnyItems = true;
      return false;
    }

    if (normalizedType !== 'interaction') {
      return true;
    }

    const interactionId = getInteractionEventId(item);

    if (!interactionId) {
      didFilterAnyItems = true;
      return false;
    }

    const isResolvedInteraction = resolvedInteractionIds.has(interactionId);

    if (
      String(item?.interactionType || '')
        .trim()
        .toLowerCase() === 'connection_setup'
    ) {
      if (isDismissedConnectionPrompt(item)) {
        didFilterAnyItems = true;
        return false;
      }

      // The card that carries its own answer (a response, or an outcome written in place) stays on record.
      const isRespondedConnectionCard = Boolean(String(item?.outcome || '').trim()) || (item?.response && typeof item.response === 'object' && !Array.isArray(item.response));

      if (isRespondedConnectionCard) {
        return true;
      }

      if (isResolvedInteraction) {
        didFilterAnyItems = true;
        return false;
      }

      return true;
    }

    if (!isResolvedInteraction) {
      didFilterAnyItems = true;
    }

    return isResolvedInteraction;
  });

  if (!didFilterAnyItems && filteredActivity.length === normalizedActivity.length) {
    return dedupeThreadEventsByIdentity({
      events: normalizedActivity
    });
  }

  return dedupeThreadEventsByIdentity({
    events: filteredActivity
  });
};

export default resolveVisibleThreadActivity;
